export default __webpack_public_path__ + "static/media/map-satellite.4dfcae2d.png";